import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

const BASE_URL = 'DocumentNoteTemplate';

/**
 * Get all document note templates for the current user's company/store
 */
export const getAllTemplates = async () => {
  const response = await axiosInstance.get(BASE_URL);
  return response.data;
};

/**
 * Get templates by document type (Ticket, Invoice, DeliveryNote, Offer, CreditNote)
 * @param {string} documentType - Document type to filter by
 */
export const getTemplatesByType = async (documentType) => {
  const response = await axiosInstance.get(`${BASE_URL}/by-type/${documentType}`);
  return response.data;
};

/**
 * Get template by ID
 * @param {number} id - Template ID
 */
export const getTemplateById = async (id) => {
  const response = await axiosInstance.get(`${BASE_URL}/${id}`);
  return response.data;
};

/**
 * Get default template for a document type
 * @param {string} documentType - Document type (Ticket, Invoice, DeliveryNote, Offer, CreditNote)
 */
export const getDefaultTemplate = async (documentType) => {
  const response = await axiosInstance.get(`${BASE_URL}/default/${documentType}`);
  return response.data;
};

/**
 * Create a new document note template
 * @param {Object} templateData - Template details
 */
export const createTemplate = async (templateData) => {
  const response = await axiosInstance.post(BASE_URL, templateData);
  return response.data;
};

/**
 * Update an existing document note template
 * @param {Object} templateData - Updated template details
 */
export const updateTemplate = async (templateData) => {
  const response = await axiosInstance.put(BASE_URL, templateData);
  return response.data;
};

/**
 * Delete a document note template
 * @param {number} id - Template ID
 */
export const deleteTemplate = async (id) => {
  await axiosInstance.delete(`${BASE_URL}/${id}`);
};

/**
 * Set a template as default for its document type
 * @param {number} id - Template ID
 */
export const setAsDefault = async (id) => {
  const response = await axiosInstance.post(`${BASE_URL}/${id}/set-default`);
  return response.data;
};

/**
 * Document type constants
 */
export const DocumentTypes = {
  TICKET: 'Ticket',
  INVOICE: 'Invoice',
  DELIVERY_NOTE: 'DeliveryNote',
  OFFER: 'Offer',
  CREDIT_NOTE: 'CreditNote',
  ALL: 'All'
};
